import { render, staticRenderFns } from "./RsaAccettazioneAnagraficaComponent.vue?vue&type=template&id=3621077b&scoped=true"
import script from "./RsaAccettazioneAnagraficaComponent.vue?vue&type=script&lang=js"
export * from "./RsaAccettazioneAnagraficaComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaAccettazioneAnagraficaComponent.vue?vue&type=style&index=0&id=3621077b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3621077b",
  null
  
)

export default component.exports